import $ from 'jquery';

$(function() {
  window.addEventListener('backgroundImageScroll', function(e: any) {
    const { progress, target } = e.detail;
    $(target).css('background-position', `center ${progress * 100}%`)
  });
});
